export default __webpack_public_path__ + "static/media/mode-15.4ea4d65a.svg";